import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Modal, Tooltip, OverlayTrigger } from 'react-bootstrap';
import QcSampleDetails from './qcSampleDetails';
import Swal from 'sweetalert2';
import toastr from 'toastr';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import { deleteQcSample } from '../../../../services/clinicPortalServices/qcSampleService';
import { trackRecentView } from '../../../../services/clinicPortalServices/recentViewService';

const panelStyles = {
    overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.3)', zIndex: 1040 },
    panel: { position: 'fixed', top: 0, right: 0, width: '420px', height: '100vh', background: '#fff', boxShadow: '-4px 0 20px rgba(0,0,0,0.15)', zIndex: 1041, display: 'flex', flexDirection: 'column', overflowY: 'auto' },
    header: { padding: '16px 20px', borderBottom: '1px solid #e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#f8f9fa' },
    title: { margin: 0, fontSize: '16px', fontWeight: 600, color: '#333' },
    body: { padding: '20px', flex: 1 },
    section: { marginBottom: '20px' },
    sectionTitle: { fontSize: '11px', fontWeight: 700, color: '#888', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '10px', paddingBottom: '6px', borderBottom: '1px solid #eee' },
    dl: { display: 'grid', gridTemplateColumns: '140px 1fr', rowGap: '8px', margin: 0 },
    dt: { fontSize: '13px', color: '#555', fontWeight: 600, paddingRight: '8px' },
    dd: { fontSize: '13px', color: '#222', margin: 0 },
    editBtn: { background: '#0066cc', color: '#fff', border: 'none', borderRadius: '4px', padding: '6px 14px', fontSize: '13px', cursor: 'pointer', marginRight: '8px' },
    closeBtn: { background: 'transparent', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#666' }
};

export default class EditBtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showCopyModal: false,
            show: false,
            showPanel: false,
            qcSampleId: props.data._id
        };
    }

    handleCopy = () => this.setState({ showCopyModal: true });
    handleCloseCopyModal = () => this.setState({ showCopyModal: false });

    handleDelete = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'This QC Sample will be archived!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, archive it!',
            cancelButtonText: 'No, keep it',
            customClass: {
                container: window.localStorage.getItem('appTheme') === 'Dark' && /clinic|lims/.test(window.location.pathname.split('/')[1]) && 'dark-swal',
                cancelButton: 'order-1',
                confirmButton: 'order-2'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                deleteQcSample({ _id: this.state.qcSampleId, name: this.props.data.name }).then(() => {
                    this.props.context.componentParent.loadGridData();
                    toastr.success('QC Sample archived successfully');
                });
            }
        });
    };

    handleShow = () => {
        this.setState({ show: true });
        const qcSample = this.props.data;
        if (qcSample) {
            trackRecentView('qc_sample', qcSample._id, qcSample.name || 'QC Sample', '/clinic/qcSamples');
        }
    };

    handleClose = () => this.setState({ show: false });

    renderPanel() {
        const d = this.props.data;
        const analytes = Array.isArray(d.analytes) ? d.analytes.map(a => a.name || a).join(', ') : (d.analytes || '—');
        return ReactDOM.createPortal(
            <>
                <div style={panelStyles.overlay} onClick={() => this.setState({ showPanel: false })} />
                <div style={panelStyles.panel}>
                    <div style={panelStyles.header}>
                        <h5 style={panelStyles.title}>QC Sample Details</h5>
                        <div>
                            {!d.isArchived && (
                                <button style={panelStyles.editBtn} onClick={() => { this.setState({ showPanel: false }); this.handleShow(); }}>
                                    <i className="fas fa-pen" style={{ marginRight: 5 }}></i>Edit
                                </button>
                            )}
                            <button style={panelStyles.closeBtn} onClick={() => this.setState({ showPanel: false })}>
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div style={panelStyles.body}>
                        <div style={panelStyles.section}>
                            <div style={panelStyles.sectionTitle}>Sample Information</div>
                            <dl style={panelStyles.dl}>
                                <dt style={panelStyles.dt}>Name</dt>
                                <dd style={panelStyles.dd}>{d.name || '—'}</dd>
                                <dt style={panelStyles.dt}>Control Type</dt>
                                <dd style={panelStyles.dd}>{d.controlType || '—'}</dd>
                                <dt style={panelStyles.dt}>Lot Number</dt>
                                <dd style={panelStyles.dd}>{d.lotNumber || '—'}</dd>
                                <dt style={panelStyles.dt}>Lot Expiration</dt>
                                <dd style={panelStyles.dd}>{d.lotExpirationDate || '—'}</dd>
                                <dt style={panelStyles.dt}>Barcode</dt>
                                <dd style={panelStyles.dd}>{d.barcode || '—'}</dd>
                                <dt style={panelStyles.dt}>Status</dt>
                                <dd style={panelStyles.dd}>{d.isArchived ? 'Archived' : 'Active'}</dd>
                                <dt style={panelStyles.dt}>Created By</dt>
                                <dd style={panelStyles.dd}>{d.createdBy || '—'}</dd>
                            </dl>
                        </div>
                        {analytes && (
                            <div style={panelStyles.section}>
                                <div style={panelStyles.sectionTitle}>Analytes</div>
                                <div style={{ fontSize: '13px', color: '#222' }}>{analytes}</div>
                            </div>
                        )}
                    </div>
                </div>
            </>,
            document.body
        );
    }

    render() {
        return (
            <div>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">Copy QC Sample</Tooltip>}>
                    <button onClick={this.handleCopy} className="edit-order-btn">
                        <i className="fas fa-copy"></i>
                    </button>
                </OverlayTrigger>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">View QC Sample</Tooltip>}>
                    <button onClick={() => this.setState({ showPanel: true })} className="edit-order-btn">
                        <i className="fas fa-eye"></i>
                    </button>
                </OverlayTrigger>
                {!this.props.data.isArchived && (
                    <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">Edit QC Sample</Tooltip>}>
                        <button onClick={this.handleShow} className="edit-order-btn">
                            <i className="fas fa-pen"></i>
                        </button>
                    </OverlayTrigger>
                )}
                {!this.props.data.isArchived && (
                    <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">Archive QC Sample</Tooltip>}>
                        <button onClick={this.handleDelete} className="edit-order-btn">
                            <i className="fas fa-trash"></i>
                        </button>
                    </OverlayTrigger>
                )}
                {this.state.showPanel && this.renderPanel()}
                {!this.props.data.isArchived && (
                    <ModalStyled size="lg" aria-labelledby="contained-modal-title-vcenter" centered show={this.state.show} onHide={this.handleClose} backdrop="static">
                        <Modal.Header closeButton>
                            <Modal.Title>Update QC Sample Information</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <QcSampleDetails qcSampleId={this.state.qcSampleId} context={this.props.context} handleClose={this.handleClose} />
                        </Modal.Body>
                    </ModalStyled>
                )}
                <ModalStyled size="lg" aria-labelledby="contained-modal-title-vcenter" centered show={this.state.showCopyModal} onHide={this.handleCloseCopyModal} backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>Copy QC Sample</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <QcSampleDetails qcSampleId={this.state.qcSampleId} context={this.props.context} handleClose={this.handleCloseCopyModal} isCopy={true} originalQcSampleId={this.state.qcSampleId} />
                    </Modal.Body>
                </ModalStyled>
            </div>
        );
    }
}
